export default function Container({ children }) {
  return <div className="container mx-auto px-4">{children}</div>;
}
